import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { GuestParticipantList } from "./GuestParticipantList";
import { GuestParticipantAdd } from "./GuestParticipantAdd";

function GuestParticipantCard(props) {
  const { t } = useTranslation();
  const [visibleParticipantAdd, setVisibleParticipantAdd] = useState(false);
  const [isAdded, setIsAdded] = useState(false);

  return (
    <Fragment>
      {visibleParticipantAdd ? (
        <GuestParticipantAdd
          toggleDialog={() => setVisibleParticipantAdd(false)}
          title={t("add_participant")}
          event={props.event}
          setIsAdded={setIsAdded}
        />
      ) : null}

      {props.event?.davetlI_ETKINLIK_TANIM_ID ? (
        <GuestParticipantList
          event={props.event}
          isAdded={isAdded}
          setIsAdded={setIsAdded}
          toggleParticipantAdd={() => setVisibleParticipantAdd(true)}
        />
      ) : null}
    </Fragment>
  );
}

export { GuestParticipantCard };
